import { ListingType } from '@domain-group/fe-allhomes-library/lib/node';
var ListingSortOrderKeys = ['PRICE_ASCENDING', 'PRICE_DESCENDING', 'LISTING_AGE_ASCENDING', 'LISTING_AGE_DESCENDING', 'UPDATED_ASCENDING', 'UPDATED_DESCENDING', 'UPCOMING_INSPECTIONS', 'UPCOMING_AUCTIONS', 'LOCATION_ASCENDING', 'LOCATION_DESCENDING', 'PROPERTY_TYPE_ASCENDING', 'PROPERTY_TYPE_DESCENDING', 'BEDROOMS_ASCENDING', 'BEDROOMS_DESCENDING', 'ROOMS_AVAILABLE_ASCENDING', 'ROOMS_AVAILABLE_DESCENDING', 'PEOPLE_WANTED_ASCENDING', 'PEOPLE_WANTED_DESCENDING'];
export var SortFields = ['PRICE', 'DATEUPDATED', 'UPDATED', 'INSPECTIONTIME', 'AUCTION', 'ADDRESS', 'PROPERTYTYPE', 'BEDROOMS', 'ROOMSAVAILABLE', 'PEOPLEWANTED', 'DISTANCE'];
export var SortDirections = ['ASC', 'DESC'];
var ListingSortOrderValues = {
  PRICE_ASCENDING: {
    name: 'PRICE_ASCENDING',
    value: 'price-asc',
    label: 'Price (Low - High)',
    urlSlug: 'lowest-price'
  },
  PRICE_DESCENDING: {
    name: 'PRICE_DESCENDING',
    value: 'price-desc',
    label: 'Price (High - Low)',
    urlSlug: 'highest-price'
  },
  LISTING_AGE_ASCENDING: {
    name: 'LISTING_AGE_ASCENDING',
    value: 'dateupdated-asc',
    label: 'Date (Oldest - Newest)',
    urlSlug: 'oldest-listing'
  },
  LISTING_AGE_DESCENDING: {
    name: 'LISTING_AGE_DESCENDING',
    value: 'dateupdated-desc',
    label: 'Date (Newest - Oldest)',
    urlSlug: 'newest-listing'
  },
  UPDATED_ASCENDING: {
    name: 'UPDATED_ASCENDING',
    value: 'updated-asc',
    label: 'Updated (Oldest - Newest)',
    urlSlug: 'oldest-updated',
    searchTypes: ['new-price', 'normal']
  },
  UPDATED_DESCENDING: {
    name: 'UPDATED_DESCENDING',
    value: 'updated-desc',
    label: 'Updated (Newest - Oldest)',
    urlSlug: 'newest-updated',
    searchTypes: ['new-price', 'normal']
  },
  UPCOMING_INSPECTIONS: {
    name: 'UPCOMING_INSPECTIONS',
    value: 'inspectiontime-asc',
    label: 'Upcoming inspections',
    urlSlug: 'inspectiontime-asc',
    listingTypes: [ListingType.SALES_RESIDENTIAL.name, ListingType.RENTAL_RESIDENTIAL.name, ListingType.SALES_BUSINESS.name, ListingType.SALES_COMMERCIAL.name, ListingType.RENTAL_COMMERCIAL.name]
  },
  UPCOMING_AUCTIONS: {
    name: 'UPCOMING_AUCTIONS',
    value: 'auction-asc',
    label: 'Upcoming auctions',
    urlSlug: 'earliest-auction',
    listingTypes: [ListingType.SALES_RESIDENTIAL.name, ListingType.SALES_COMMERCIAL.name, ListingType.SALES_BUSINESS.name]
  },
  LOCATION_ASCENDING: {
    name: 'LOCATION_ASCENDING',
    value: 'address-asc',
    label: 'Location (A - Z)',
    urlSlug: 'address-asc'
  },
  LOCATION_DESCENDING: {
    name: 'LOCATION_DESCENDING',
    value: 'address-desc',
    label: 'Location (Z - A)',
    urlSlug: 'address-dec'
  },
  PROPERTY_TYPE_ASCENDING: {
    name: 'PROPERTY_TYPE_ASCENDING',
    value: 'propertytype-asc',
    label: 'Property Type (A - Z)',
    urlSlug: 'propertytype-asc'
  },
  PROPERTY_TYPE_DESCENDING: {
    name: 'PROPERTY_TYPE_DESCENDING',
    value: 'propertytype-desc',
    label: 'Property Type (Z - A)',
    urlSlug: 'propertytype-desc'
  },
  BEDROOMS_ASCENDING: {
    name: 'BEDROOMS_ASCENDING',
    value: 'bedrooms-asc',
    label: 'Bedrooms (Min - Max)',
    urlSlug: 'bedrooms-asc',
    listingTypes: [ListingType.SALES_RESIDENTIAL.name, ListingType.RENTAL_RESIDENTIAL.name]
  },
  BEDROOMS_DESCENDING: {
    name: 'BEDROOMS_DESCENDING',
    value: 'bedrooms-desc',
    label: 'Bedrooms (Max - Min)',
    urlSlug: 'bedrooms-desc',
    listingTypes: [ListingType.SALES_RESIDENTIAL.name, ListingType.RENTAL_RESIDENTIAL.name]
  },
  ROOMS_AVAILABLE_ASCENDING: {
    name: 'ROOMS_AVAILABLE_ASCENDING',
    value: 'roomsavailable-asc',
    label: 'Rooms Available (Min - Max)',
    urlSlug: 'roomsavailable-asc',
    listingTypes: [ListingType.SHARE_RESIDENTIAL.name]
  },
  ROOMS_AVAILABLE_DESCENDING: {
    name: 'ROOMS_AVAILABLE_DESCENDING',
    value: 'roomsavailable-desc',
    label: 'Rooms Available (Max - Min)',
    urlSlug: 'roomsavailable-desc',
    listingTypes: [ListingType.SHARE_RESIDENTIAL.name]
  },
  PEOPLE_WANTED_ASCENDING: {
    name: 'PEOPLE_WANTED_ASCENDING',
    value: 'peoplewanted-asc',
    label: 'People Wanted (Min - Max)',
    urlSlug: 'peoplewanted-asc',
    listingTypes: [ListingType.SHARE_RESIDENTIAL.name]
  },
  PEOPLE_WANTED_DESCENDING: {
    name: 'PEOPLE_WANTED_DESCENDING',
    value: 'peoplewanted-desc',
    label: 'People Wanted (Max - Min)',
    urlSlug: 'peoplewanted-desc',
    listingTypes: [ListingType.SHARE_RESIDENTIAL.name]
  }
};
export var ListingSortOrder = ListingSortOrderValues;
export var availableSortOrders = searchOptions => Object.values(ListingSortOrder).filter(_ref => {
  var listingTypes = _ref.listingTypes,
    searchTypes = _ref.searchTypes;
  return (listingTypes ? listingTypes.includes(searchOptions.listingType) : true) && (searchTypes ? searchTypes.includes(searchOptions.searchType) : true);
});
export var sortOrderByValue = value => {
  var lowerCasedValue = value === null || value === void 0 ? void 0 : value.toLowerCase();
  var withDirection = lowerCasedValue !== null && lowerCasedValue !== void 0 && lowerCasedValue.includes('-') ? lowerCasedValue : "".concat(lowerCasedValue, "-asc");
  return Object.values(ListingSortOrder).find(order => order.value === withDirection);
};
export var sortOrderBySlug = slug => Object.values(ListingSortOrder).find(order => order.urlSlug === slug);